<ng-container [formGroup]="form">
  <mat-checkbox
    [formControlName]="controlName"
    [attr.data-test-id]="config.testId"
    class="filter__checkbox-label mt-0 mb-4">
    {{config.title}}
  </mat-checkbox>
</ng-container>
